import gql from 'graphql-tag'

export const DELETE_STYLE_MUTATION = gql`
  mutation DeleteStyle($styleId: UUID!) {
    deleteStyle(styleId: $styleId)
  }
`
